import dateValidators from '../../form-validators/date.validators';
import { useForm } from '../../hooks/useForm.hook';
import { useResourceInput } from '../../hooks/useResourceInput';
import procedureService from '../../services/api/procedure.service';
import Datepicker from '../forms/Datepicker';

const DossierProcedureDetails = ({ dossierId, startDate, endDate, onUpdated, read, write }) => {
  const { isSubmitting, data, reset, input, submitStart, submitOk, submitError } = useForm({
    startDate,
    endDate
  });
  const resource = {
    isFetching: false,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options = {}) => {
      submitStart();
      procedureService.update(
        dossierId,
        { [field]: value },
        {
          onSuccess: () => {
            submitOk();
            input(value, field);
            onUpdated(value, field);
            options.onSuccess();
          },
          onError: (message) => {
            submitError({ [field]: message });
            options.onError(message);
          }
        }
      );
    },
    validators: {
      startDate: (value) => dateValidators.lteNonRequired(value, endDate),
      endDate: (value) => dateValidators.gteNonRequired(value, startDate)
    },
    onCancel: reset
  };

  return (
    <div className="spo-o-dossier-procedure-details u-margin-bottom-lg">
      <div className="row">
        <div className="col-xs-12 col-md-6 col-lg-4 u-margin-bottom-xs">
          <Datepicker
            label="Startdatum begeleiding"
            {...useResourceInput('startDate', resource, '', { ignoreTouched: true })}
            maxDate={data?.endDate}
            readOnly={!write}
          />
        </div>
        <div className="col-xs-12 col-md-6 col-lg-4 u-margin-bottom-xs">
          <Datepicker
            label="Einddatum begeleiding"
            {...useResourceInput('endDate', resource, '', { ignoreTouched: true })}
            minDate={data?.startDate}
            readOnly={!write}
          />
        </div>
      </div>
    </div>
  );
};

export default DossierProcedureDetails;
